module.exports = __webpack_public_path__ + "img/self-stock-added.c1533f5c.svg";